var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCsvFile = function SvgCsvFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#30A8FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.83333
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.083 20.081c0.221 0 0.4329-0.0878 0.5892-0.244 0.1563-0.1563 0.2441-0.3683 0.2441-0.5893v-13.352c3e-4 -0.65408-0.1282-1.3018-0.3783-1.9062s-0.6168-1.1536-1.0792-1.6162-1.0114-0.82961-1.6156-1.08c-0.6043-0.25038-1.252-0.37926-1.9061-0.37926h-10.021c-0.22102 0-0.43298 0.087797-0.58926 0.24408s-0.24408 0.36824-0.24408 0.58926v17.5c0 0.221 0.0878 0.433 0.24408 0.5893 0.15628 0.1562 0.36824 0.244 0.58926 0.244h14.167z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.75 0.98438v3.2633c0 0.22101 0.0878 0.43297 0.2441 0.58925s0.3682 0.24408 0.5892 0.24408h3.2667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.0834 15.914c-0.66304 0-1.2989-0.2634-1.7678-0.7323-0.46884-0.4688-0.73224-1.1047-0.73224-1.7677 0-0.6631 0.2634-1.299 0.73224-1.7678s1.1047-0.7322 1.7678-0.7322"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.25 10.914h-1.4167c-0.23367-0.0015-0.46158 0.0725-0.6497 0.2112-0.18812 0.1386-0.32638 0.3343-0.39415 0.5579-0.06776 0.2237-0.0614 0.4632 0.01814 0.6829 0.07954 0.2198 0.22799 0.4079 0.42321 0.5363l1.5334 1.0225c0.1952 0.1281 0.3438 0.3158 0.4237 0.5352s0.0868 0.4587 0.0196 0.6823-0.2048 0.4195-0.3923 0.5586c-0.1876 0.1391-0.4151 0.2138-0.6485 0.2131h-1.4167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.417 10.914v1.25c0 1.3523-0.4386 2.6681-1.25 3.75-0.8114-1.0819-1.25-2.3977-1.25-3.75v-1.25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(0 .5)",
    width: 20,
    height: 20,
    fill: "#fff"
  })))));
};
export default SvgCsvFile;